/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./AIWebChatsMessages.css";
import {
  Channel,
  Window,
  ChannelHeader,
  MessageList,
  MessageInput,
  Thread,
} from "stream-chat-react";
import { Channel as ChannelType } from "stream-chat/dist/types/channel";
import { DefaultGenerics } from "stream-chat/dist/types/types";
import "stream-chat-react/dist/css/v2/index.css";

type props = {
  channel: ChannelType<DefaultGenerics>;
};

export const AIWebChatsMessages: React.FC<props> = ({ channel }) => {
  return (
    <div className="channel-wrapper">
      <Channel channel={channel}>
        <Window>
          <ChannelHeader title={channel._data.name} />
          <MessageList
          // renderText={(text) => <CustomRenderText text={text} />}
          />
          <MessageInput />
        </Window>
        <Thread />
      </Channel>
    </div>
  );
};
